import { requestAuth } from './index'

export const getHomeForYou = () => {
  return requestAuth({
    url: 'content/ex/v2/for-you',
    method: 'get',
  })
}

export const getEventHighlights = () => {
  return requestAuth({
    url: '/event/ex/v1/events/highlights',
    method: 'get',
  })
}

export const getPromotionBanner = () => {
  return requestAuth({
    url: '/console/ex/v1/promo-banner',
    method: 'get',
  })
}

const HomeAgregator = {
  getHomeForYou,
  getEventHighlights,
  getPromotionBanner,
}

export default HomeAgregator
